import { FC } from 'react';
import { SuggestedReportConfigItem } from '../../config/suggested-reports-config';

import { Stack, Box } from '@mui/material';
import { VyDescriptionTitle } from '../../../../../components/new-design/data-display/VyDescriptionTitle/VyDescriptionTitle';
import { VyDivider } from '../../../../../components/new-design/atoms';
import { SIZES } from '../../../../../components/types/sizes';
import { Link } from 'react-router-dom';
import { getReportHref } from '../suggested-reports-section/suggested-reports-config';
type SuggestedReportsSectionItemProps = {
  data: SuggestedReportConfigItem;
};

export const SuggestedReportsSectionItem: FC<SuggestedReportsSectionItemProps> = ({ data }) => {
  return (
    <Stack
      sx={{
        gap: 2,
        flexGrow: 1,
        maxWidth: "277px"
      }}>
      <VyDescriptionTitle
        title={data.title}
        icon={data.icon}
        avatarSx={{ backgroundColor: data.iconBackgroundColor, height: 30, width: 30 }}
        cardSx={{
          '& .MuiCardHeader-avatar.MuiCardHeader-avatar': {
            marginRight: '10px',
          },
        }}
        size={SIZES.SMALL}
        boldTitle
      />
      <Stack divider={<VyDivider />}>
        {data.options.map(({ title, description, type }) => (
          <Link key={title} to={getReportHref(type)}>
            <Box
              sx={{
                padding: 2,
                '&:hover': {
                  backgroundColor: '#E8EBF2',
                },
              }}
            >
              <VyDescriptionTitle
                title={title}
                subTitle={description}
                size={SIZES.LARGE}
                cardSx={{
                  '& .MuiCardHeader-title': {
                    marginBottom: '3px',
                  },
                }}
              />
            </Box>
          </Link>
        ))}
      </Stack>
    </Stack>
  );
};
